import React from 'react';
import styled from '@emotion/styled';
import { Row, StyledIconButton } from '../../../../../ui';
import { FormProvider } from 'react-hook-form';
import { SignUpErrorMessage } from '../../../../auth/sign-up/ui/form/SignUpErrorMessage';
import { useCreateUserAccountForm } from './hooks/useCreateUserAccountForm';
import { useCreateUserAccountSubmit } from './hooks/useCreateUserAccountSubmit';
import { Password } from '../../../../auth/shared/form-fields/Password';
import { ConfirmPassword } from '../../../../auth/shared/form-fields/ConfirmPassword';
import { CreateUserAccountSubmit as Submit } from './CreateUserAccountSubmit';
import { ErrorBar } from '../../../../shared/components';
import Responsive from '../../../../../ui/utils/Responsive';

export const CreateUserAccountForm = () => {
	const form = useCreateUserAccountForm();
	const { submit, success, error } = useCreateUserAccountSubmit();

	if (success) {
		return null;
	}

	return (
		<form onSubmit={form.handleSubmit(submit)}>
			<FormProvider {...form}>
				<Wrap columns={[3, { mobileXL: 1 }]}>
					<Password autoComplete="new-password" />
					<ConfirmPassword />
					<Submit />
				</Wrap>
				{error && (
					<ErrorBar>
						<SignUpErrorMessage error={error} />
					</ErrorBar>
				)}
			</FormProvider>
		</form>
	);
};

const Wrap = styled(Row)`
	${StyledIconButton} {
		margin-top: 48px;
		font-family: inherit;
	}

	&:last-of-type {
		margin-bottom: 0;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-top: 0;
	}
`;
